import { z } from "zod";

/**
 * MotivoAfastamentoSchema
 */

export const MotivoAfastamentoSchema = z.object({
  ativo: z.coerce.number(),
  descricaoMotivo: z.string(),
});

/**
 * MotivoAfastamentoForm
 */

export type MotivoAfastamentoForm = z.infer<typeof MotivoAfastamentoSchema>;

/**
 * Default value
 */

export const defaultMotivoAfastamentoForm: MotivoAfastamentoForm = {
  ativo: 1,
  descricaoMotivo: '',
}